<template>
  <div class="error-container">
    <h2>Failed to initialize app</h2>
  </div>
</template>

<script>
import { appCode } from '@/common/consts';

export default {
  name: appCode,
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.error-container {
  font-family: inherit;
  margin-top: 40px;
  text-align: center;
}

h2 {
  font-size: 1rem;
}
</style>
